<form #personal="ngForm" (ngSubmit)="updatePatientData(personal)">
  <div class="row form-group">
    <div class="col">
      <label for="">Is {{LABEL.Patient}} a <strong>Minor</strong> ?</label>
      <div class="form-inline">
        <label class="form-check-container m-0">Yes
          <input class="form-check-input" type="radio" [(ngModel)]="patientData.is_minor" name="minor" value="1"
            required>
          <span class="checkmark"></span>
        </label>
        <label class="form-check-container m-0">No
          <input class="form-check-input" type="radio" [(ngModel)]="patientData.is_minor" name="minor" value="0"
            required>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="row form-group" *ngIf="patientData.is_minor === '1'">
    <div class="col">
      <label>Guardian Salutation</label>
      <select name="guardianSalutation" id="" class="form-control" [(ngModel)]="patientData.guardian_title">
        <option *ngFor="let item of salutations" [value]="item.title">
          {{item.title}}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Guardian First Name*</label>
      <input required type="text" class="form-control" #guardianFirstName="ngModel" name="guardianFirstName"
        [(ngModel)]="patientData.guardian_first_name" minlength="2" maxlength=25 style="text-transform:capitalize"
        [ngClass]="{'has-error':guardianFirstName.invalid && (guardianFirstName.touched || personal.submitted)}">
    </div>
    <div class="col">
      <label>Guardian Last Name*</label>
      <input required type="text" class="form-control" #guardianLastName="ngModel" name="guardianLastName" [(ngModel)]="patientData.guardian_last_name"
        minlength="2" maxlength=25 style="text-transform:capitalize" [ngClass]="{'has-error':guardianLastName.invalid && (guardianLastName.touched || personal.submitted)}">
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>{{LABEL.Patient}} Salutation</label>
      <select name="salutation" id="" class="form-control" [(ngModel)]="patientData.title">
        <option *ngFor="let item of salutations" [value]="item.title">
          {{item.title}}
        </option>
      </select>
    </div>
    <div class="col">
      <label>{{LABEL.Patient}} First Name*</label>
      <input required type="text" class="form-control" #patientFirstName="ngModel" name="patientFirstName" [(ngModel)]="patientData.patient_first_name"
        minlength="2" maxlength=25 style="text-transform:capitalize" [ngClass]="{'has-error':patientFirstName.invalid && (patientFirstName.touched || personal.submitted)}">
    </div>
    <div class="col">
      <label>{{LABEL.Patient}} Last Name*</label>
      <input required type="text" class="form-control" #patientLastName="ngModel" name="patientLastName" [(ngModel)]="patientData.patient_last_name"
        minlength="2" maxlength=25 style="text-transform:capitalize" [ngClass]="{'has-error':patientLastName.invalid && (patientLastName.touched || personal.submitted)}">
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>{{LABEL.Patient}} Date Of Birth :</label>
      <div class="input-group">
        <input required #dob="ngModel" name="dob" readonly class="form-control" placeholder="Select Date"
               [bsConfig]="bsConfig"
               [(ngModel)]="patientData.dob" #dobdp="bsDatepicker" bsDatepicker [maxDate]="maxDate" [ngClass]="{'has-error':dob.invalid && (dob.touched || personal.submitted)}" [readOnly]="false">
        <div class="input-group-prepend" (click)="dobdp.toggle()" [attr.aria-expanded]="dobdp.isOpen">
          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
        </div>
      </div>
      <!-- <div class="row p-l-15 p-r-15">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <select name="month" class="form-control" [(ngModel)]="dob.month">
            <option value="">Month</option>
            <option *ngFor="let month of months">
              {{month.month_name}}
            </option>
          </select>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <select name="date" class="form-control" [(ngModel)]="dob.date">
            <option value="">Date</option>
            <option *ngFor="let date of dates">
              {{date}}
            </option>
          </select>

        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
          <select name="year" class="form-control" [(ngModel)]="dob.year">
            <option value="">Year</option>
            <option *ngFor="let year of birthYears">
              {{year}}
            </option>
          </select>

        </div>
      </div> -->
    </div>
    <div class="col">
      <label>Social Security Number*</label>
      <input required type="text" class="form-control" #patientSSN="ngModel" name="patientSSN" [(ngModel)]="patientData.patient_ssn"
        minlength=9 appNumberOnly [ngClass]="{'has-error':(patientSSN.invalid) &&
(patientSSN.touched || personal.submitted)}"> <!-- [textMask]="{mask: ssn_mask,guide:false}" -->
   <!-- <p class="text-danger" *ngIf="!validateTin(patientData.patient_ssn)">Invalid SSN Number</p> -->
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label for="">Gender</label>
      <div class="form-inline">
        <label class="form-check-container m-0">Male
          <input class="form-check-input" type="radio" [(ngModel)]="patientData.patient_gender" name="gender" value="1"
            required>
          <span class="checkmark"></span>
        </label>
        <label class="form-check-container m-0">Female
          <input class="form-check-input" type="radio" [(ngModel)]="patientData.patient_gender" name="gender" value="2"
            required>
          <span class="checkmark"></span>
        </label>
        <label class="form-check-container m-0">Others
          <input class="form-check-input" type="radio" [(ngModel)]="patientData.patient_gender" name="gender" value="3"
            required>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    <div class="col">
      <label>Phone Number*</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupPrepend3">+1</span>
        </div>
        <input required type="text" class="form-control" #patientPhone="ngModel" name="patientPhone" [(ngModel)]="patientData.patient_mobile"
          [maxlength]="phone_length" [minlength]="min_phone_length" appNumberOnly [ngClass]="{'has-error':patientPhone.invalid &&
          (patientPhone.touched || personal.submitted)}"> <!-- [textMask]="{mask: mask,guide:false}" -->
      </div>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>Email Address*</label>
      <input name="userName" disabled type="email" [(ngModel)]="patientData.patient_email" class="form-control" />
    </div>
    <div class="col">
      <label>DL Number*</label>
      <input required #DLNumber="ngModel" name="DLNumber" [ngClass]="{'has-error':DLNumber.invalid &&
(DLNumber.touched || personal.submitted)}"
        type="text" [(ngModel)]="patientData.dl_number" maxlength=20 class="form-control" />
    </div>
  </div>

  <div class="row mt-4 mb-4"
  *ngIf="planInfo && planInfo.upload_customer_document && planInfo.upload_customer_document == 1">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <label class="mb-0">Proof of ID</label>
    <div class="col-12 col-md-6 col-lg-5">
      <div class="row pt-2 pb-2 " style="background-color: #F9F9F9;"
        style="align-items: center; display: flex;">
        <div class="col-8 col-md-10">
          <span style="font-size: 13px;color: #313131;"
            *ngIf="!patientData.dl_doc || patientData.dl_doc==null">Please upload a clear copy of your
            Driver’s License or another government-issued proof of ID.</span>
          <span style="font-size: 13px" *ngIf="patientData.dl_doc && patientData.dl_doc!=null"><a
              href="{{patientData.dl_doc}}" target="_blank" style="text-decoration: none;"
              class="me-2"><i class="fa fa-file-text-o me-2"
                style="font-size:20px;cursor: pointer;"></i>Proof of ID
            </a></span>
        </div>
        <div class="col-4 col-md-2 col-lg-2 text-center">
          <div *ngIf="!patientData.dl_doc || patientData.dl_doc==null">
            <label class="text-primary text-center" for="fileInput" style="cursor:pointer;"> <img
                src="../../../../assets/svg/upload-icon.svg">
            </label>
            <input class="d-none upload " name="profilePic" id="fileInput" accept="image/*,.pdf"
              #fileUpload type="file" [(ngModel)]="imageUploader" name="imgUploader"
              (change)="fileChangeEvent($event)" (click)="onFileInputClick($event)">
          </div>
          <div class="col-4 col-md-2 col-lg-2 text-end my-auto">
            <div *ngIf="patientData.dl_doc && patientData.dl_doc!=null">
              <span class="m-l-15">
                <i class="fa fa-trash" style="color: #f05050;font-size:22px;cursor: pointer;"
                  (click)="deleteDocPopUp(patientData.dl_id)"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



  <div class="row form-group">
    <div class="col">
      <label>Address*</label>
      <input required #Address="ngModel" name="Address" [ngClass]="{'has-error':Address.invalid &&
(Address.touched || personal.submitted)}"
        type="text" maxlength=100 [(ngModel)]="patientData.patient_address" class="form-control" />
    </div>
    <div class="col">
      <label>Zipcode*</label>
      <input required #Zipcode="ngModel" name="Zipcode" [ngClass]="{'has-error':Zipcode.invalid &&
(Zipcode.touched || personal.submitted)}"
        type="text" maxlength=6 [(ngModel)]="patientData.zip" (ngModelChange)="getZip($event,1)" class="form-control" /> <!-- [textMask]="{mask: zip_mask, guide:false}" -->
      <ul class="dropdown-menu p-0 m-l-15" [ngClass]="{'show': zips.length > 0}">
        <li>
          <div class="list-group">
            <a class="list-group-item zipCode" (click)="selectZip(item)" *ngFor="let item of zips">{{item.zip}}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>City</label>
      <input name="city" readonly type="text" [(ngModel)]="patientData.city" class="form-control" />
    </div>
    <div class="col">
      <label>State</label>
      <input readonly name="state" type="text" [(ngModel)]="patientData.state_name" class="form-control" />
    </div>
  </div>
  <h4 class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 m-t-20 m-b-20"><strong>Employer Information</strong></h4>
  <div class="row form-group">
    <div class="col">
      <label>Employer Name*</label>
      <input required type="text" [ngClass]="{'has-error':employerName.invalid &&
(employerName.touched || personal.submitted)}"
        class="form-control" #employerName="ngModel" name="employerName" [(ngModel)]="patientData.employer_name"
        minlength="2" maxlength=100 style="text-transform:capitalize">
    </div>
    <div class="col">
      <label>Employer Phone Number*</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupPrepend3">+1</span>
        </div>
        <input required type="text" [ngClass]="{'has-error':employerPhone.invalid &&
(employerPhone.touched || personal.submitted)}"
          class="form-control" #employerPhone="ngModel" name="employerPhone" [(ngModel)]="patientData.employer_mobile"
          maxlength=15 minlength=10 appNumberOnly> <!-- [textMask]="{mask: mask,guide:false}" -->
      </div>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>Employer Address*</label>
      <input required type="text" [ngClass]="{'has-error':employerAddress.invalid &&
(employerAddress.touched || personal.submitted)}"
        #employerAddress="ngModel" name="employerAddress" maxlength=100 [(ngModel)]="patientData.employer_address"
        class="form-control" />
    </div>
    <div class="col">
      <label>Employer Zipcode*</label>
      <input required #EmpZipCode="ngModel" name="EmpZipCode" [ngClass]="{'has-error':EmpZipCode.invalid &&
(EmpZipCode.touched || personal.submitted)}" 
        type="text" maxlength=6 [(ngModel)]="patientData.employer_zip" (ngModelChange)="getZip($event,2)" class="form-control" /> <!-- [textMask]="{mask: zip_mask, guide:false}" -->
      <ul class="dropdown-menu p-0 m-l-15" [ngClass]="{'show': empZips.length > 0}">
        <li>
          <div class="list-group">
            <a class="list-group-item zipCode" (click)="selectEmpZip(item)" *ngFor="let item of empZips">{{item.zip}}</a>
          </div>
        </li>
      </ul>

    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>Employer City</label>
      <input name="employerCity" readonly type="text" [(ngModel)]="patientData.employer_city" class="form-control" />
    </div>
    <div class="col">
      <label>Employer State</label>
      <input readonly name="employerState" type="text" [(ngModel)]="patientData.employer_state" class="form-control" />
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <label>Annual Income*</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupPrepend3">$</span>
        </div>
        <input required type="text" [ngClass]="{'has-error':annualIncome.invalid &&
          (annualIncome.touched || personal.submitted)}"
          class="form-control" #annualIncome="ngModel" name="annualIncome" [(ngModel)]="patientData.annual_income" (keypress)="enterNumberOnly($event)" onKeyPress="if(this.value.length==7) return false;" [type]="is_android_device ? 'number' : 'text'"
          max="100000" min="0" step="0.01" appTwoDigitDecimaNumber>
      </div>
    </div>
    <div class="col"></div>
  </div>
  <fieldset>
    <div class="p-t-20 p-b-20 d-flex justify-content-end">
      <button class="btn btnDefault" type="submit">Next</button>
    </div>
  </fieldset>
</form>
